/**
 * @module state/createStore
 * Set up the Redux store, and attach debuggers, top-level window
 * This should only be used by `src/index.js` (or possibly tests).
 */

import {composeWithDevTools} from "redux-devtools-extension";
import {createStore, applyMiddleware} from "redux";
import {routerMiddleware} from "react-router-redux";
import createSagaMiddleware from "redux-saga";
import {default as createSagaMonitor, logSagas} from "lib/saga-monitor";
import logger from "lib/log";

import {history} from "state/history";
import rootSaga from "state/rootSaga";
import rootReducer from "state/rootReducer";
import rootDehydrate from "state/rootDehydrate";
import {attachPersistence} from "state/persist";

import {processMetadata, goBack, processGooglePayResponse} from "state/app/actions";
import { saveAudit } from "state/school_money/actions";


// create the store, and other state-related things
// export saga middleware, history and store
export const sagaMiddleware = createSagaMiddleware({
  sagaMonitor: createSagaMonitor()
});

export const store = createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(
      routerMiddleware(history), // for dispatching history actions
      sagaMiddleware
    )
  )
);


// Attach persistence to store
// dispatches STATE_HYDRATE action if persisted state found
// subscribes to store to serialize upon each update
attachPersistence(store, rootDehydrate);

// Expose app API
window.app = {
  process_metadata: (metadata) => store.dispatch( processMetadata(metadata) ),
  back: () => store.dispatch ( goBack(history.location) ),
  process_google_pay_response: (response) => ( processGooglePayResponseFromNativeApp(response) ),
  // Expose debug tools namespace for remote debugging
  // It is very important this is NEVER USED in application code - only debug/inspect
  debug: {
    store,
    logger,
    logSagas
  }
}

// Callback function used by native android app to complete Google pay process
function processGooglePayResponseFromNativeApp(response){
    store.dispatch( saveAudit("Google pay response from native: " + JSON.stringify(response)) );

  store.dispatch( processGooglePayResponse(response) );
  return "true";
}

// Finally, run the root saga
sagaMiddleware.run(rootSaga);



// WEBPACK FOOTER //
// ./src/state/createStore.js